import './FlagsView.css';
import React, { useState } from 'react';
import { MACHINEAPPS_SAVE_DISABLED_FLAG } from '../constants';

export function FlagsView() {
  const [isSaveDisabled, setSaveDisabled] = useState(localStorage.getItem(MACHINEAPPS_SAVE_DISABLED_FLAG) === 'true');

  const toggleSaveDisable = () => {
    if (isSaveDisabled) {
      localStorage.removeItem(MACHINEAPPS_SAVE_DISABLED_FLAG);
    }
    else {
      localStorage.setItem(MACHINEAPPS_SAVE_DISABLED_FLAG, 'true');
    }
    setSaveDisabled(!isSaveDisabled);
  };

  return <div className='machine_app_app_flags_enabler_view'>
    <h3>Flags</h3>

    <div className="machine_app_app_flags_enabler_view_item">
      <input readOnly type="checkbox" onChange={toggleSaveDisable} checked={isSaveDisabled} />
      <label> Disable Save</label>
    </div>
  </div>;
}